import { featureToggleSelector } from './featureToggleSelector';
import { IState } from '../../store';

export const selectHidingPhoneNumberEnabled = (state: IState) =>
  featureToggleSelector(state).isHidingPhoneNumberEnabled;
